export const LATIN_ONLY_NAME_REGEXP = /^[\d\s'.A-Za-z]*$/gu;
export const LATIN_ONLY_ADDRESS_REGEXP = /^[\d\s#%&(),./@A-Za-z-]*$/gu;
export const USERNAME_REGEXP = /[\w!#'.^~-]/gu;
export const BIO_REGEXP = /[^\w.\-\s]/gu;
export const SEARCH_QUERY_TRANSFORM_REGEXP = /[^\s\dA-Za-z-]/gu;
